import React, { memo, PropsWithChildren } from 'react'
import { INavListFooterIndicatorProps } from 'transfix-ui/components/NavListFooterIndicator'
import { SideNavDrawer } from 'transfix-ui/components/SideNavDrawer'
import { INavRouteGroup, INavRoute } from 'types'
import { NavProvider } from 'utils/context/NavContext'
import { SideNav } from './SideNav'
import 'scss/5_components/_sidenav.scss'

export enum SideNavThemes {
  light = 'light',
  dark = 'dark',
}

export interface ISideNavWrapperProps {
  expanded?: boolean
  theme?: SideNavThemes
  routes: INavRoute[]
  secondaryRoutes?: INavRoute[]
  homeRoute?: string
  logo?: React.ReactElement
  onLogout?: () => void
  onSupport?: () => void
  persistNavBar?: boolean
  /**
   * @default []
   */
  navRouteGroups?: INavRouteGroup[]
  /**
   * @default false
   */
  isNewSideNavEnabled?: boolean
  navFooterIndicator?: INavListFooterIndicatorProps
}

const getActivePageTitle = (navLinks: INavRoute[], href: string): string => {
  const locationInList = navLinks.find(link => {
    const { location = '' } = link || {}
    if (!location) return undefined
    return href.includes(location)
  })

  if (locationInList) return locationInList.name
  return ''
}

export const SideNavWrapper = memo<PropsWithChildren<ISideNavWrapperProps>>(
  ({
    theme = SideNavThemes.light,
    expanded,
    children,
    routes: primaryRoutes,
    secondaryRoutes,
    homeRoute = '',
    logo,
    onLogout,
    onSupport,
    persistNavBar,
    navRouteGroups = [],
    isNewSideNavEnabled = false,
    navFooterIndicator = {},
  }) => {
    const currentListLink = [...primaryRoutes, ...(secondaryRoutes ?? [])]
    const activePageTitle: string = getActivePageTitle(currentListLink, global.location.href)

    return (
      <NavProvider initialState={expanded}>
        <div className='flex with-sidenav'>
          {isNewSideNavEnabled && !!navRouteGroups?.length ? (
            <SideNavDrawer
              homeRoute={homeRoute}
              navRouteGroups={navRouteGroups}
              logo={logo}
              navFooterIndicator={navFooterIndicator}
            />
          ) : (
            <SideNav
              persistNavBar={persistNavBar}
              currentPageTitle={activePageTitle}
              primaryNavLinks={primaryRoutes}
              secondaryNavLinks={secondaryRoutes}
              homeRoute={homeRoute}
              theme={theme}
              logo={logo}
              onLogout={onLogout}
              onSupport={onSupport}
            />
          )}
          <main className='ma0 pa0 flex flex-column'>{children}</main>
        </div>
      </NavProvider>
    )
  }
)
